import React, { useEffect, useState } from 'react';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { TableBaseStyle } from '../../../baseStyle/tableBaseStyle';

import DateTImeDiv from '../../atoms/Div/DateTImeDiv';
import OKCancelDialog from '../../atoms/Dialog/OKCancelDialog';
import SimpleDialog from '../../atoms/Dialog/SimpleDialog';

import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LearnStatType, SpeedKind } from '../../../Constant';
import { ErrorCode } from '../../../ErrorCode';
import LearnResultDialog, { LearnResultDialogResponse } from '../../molecules/Dialog/LearnResultDialog';
import GropuListComGrid from '../../molecules/Grid/GropuListComGrid';
import DevListLearnResultButton from '../../molecules/Button/DevListLearnResultButton';

import DevListStudyButton from './DevListStudyButton';
import DeviceListStatErrorButton from './DeviceListStatErrorButton';
import { TableUseStyle } from './DeviceListStyle';
import { V_DEV_LIST, DeviceLists, deviceListValidate } from './DeviceList';

import { GroupListType, GetAllGroupList } from '../../../function/GroupDataModel';
import {
  PLCManualCollectionRequest,
  PLCStudyRequest,
  PLCStudyCancelRequest,
  PLCRecollectionCancelRequest,
} from '../../../function/PLCCommunicateModel';
import { IsConanAirPlc, IsPartialDischargePlc } from '../../../function/PlcNoModel';
import { useModal } from '../../../function/useModal';

type Props = {
  tableContainerStyle: string;
};

type ManualCollectionActionType = 'manualRequest' | 'recollectionCancelRequest';

const DeviceListGrid: React.FC<Props> = (props) => {
  const history = useHistory();
  const classes = TableUseStyle();
  const baseClasses = TableBaseStyle();
  const { t } = useTranslation();

  const [okCancelDialogOpen, setOkCancelDialogOpen] = React.useState(false);
  const [manualCollectionActionType, setManualCollectionActionType] = useState<ManualCollectionActionType>('manualRequest');
  const [messageDialogOpen, setMessageDialogOpen] = React.useState(false);
  const [showMessage, setShowMessage] = React.useState<string>('');
  const [selectDevIndex, setSelectDevIndex] = React.useState<number>(0);

  const [selectedID, setSelectedID] = useState(0);
  const [deviceArray, setDeviceArray] = useState<DeviceLists>([]);
  const [open, setOpen] = React.useState(false);
  const [deviceIndex, setDeviceIndex] = React.useState(0);
  const [groupListInfo, setGroupListInfo] = useState<GroupListType>({
    TM_TRD_GROUP_SETs: [],
    RT_TRD_GROUP_SETs: [],
    PH_CUR_GROUP_SETs: [],
    SIG_CMP_GROUP_SETs: [],
    SIGC_CMP_GROUP_SETs: [],
    FFT_CMP_GROUP_SETs: [],
    FFTC_CMP_GROUP_SETs: [],
    XY_CMP_GROUP_SETs: [],
    GroupListsComModels: [],
    TrendSettings: {
      MeasKinds: [],
      DeviceLists: [],
      ItemLists: [],
      DataKinds: [],
      AlarmKinds: [],
      AlarmLimits: [],
      DeviceUnitInfos: [],
      ColSetInfos: [],
      KIND_NO_NAME_SETs: [],
      JudgeSetSelect: [],
      MClcTypes: [],
      SetPartDisList: [],
    },
    PhCurSelectItems: [],
    DeviceSelects: [],
    DeviceConanSelects: [],
    XYDeviceSelects: [],
  });
  const [rowno, setRowno] = useState<number>(-1);
  //学習結果ダイアログ
  const [flgLearnResDlg, learnResDlg] = useModal<LearnResultDialogResponse>();

  useEffect(() => {
    getData();
    const interval = setInterval(() => {
      getData();
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleTransitionPage = (pathname: string, state: any) => {
    history.push({
      pathname: pathname,
      state: state,
    });
  };

  const handleDialogShow = () => {
    setOpen(true);
  };

  const handleDialogClose = () => {
    console.debug('handleDialogClose');
    setOpen(false);
  };

  /**
   * PLC手動収集要求OK処理
   */
  const handlePLCManualCollectionOK = () => {
    PLCManualCollectionRequest(selectDevIndex)
      .then((ret) => {
        if (ret.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          setShowMessage(t('DeviceListGrid.手動収集を要求しました', '手動収集を要求しました'));
          deviceArray[rowno].IsManualColection = 3;
          setDeviceArray(deviceArray.concat());
        } else if (ret.ErrorCode === ErrorCode.ERR_CODE_PLC_REQUEST_DUPLICATION) {
          setShowMessage(t('DeviceListGrid.既に要求中です', '既に要求中です'));
        } else {
          setShowMessage(t('DeviceListGrid.手動収集の要求に失敗しました', '手動収集の要求に失敗しました。'));
        }
        setMessageDialogOpen(true);
      })
      .catch((error) => {
        setShowMessage(t('DeviceListGrid.手動収集の要求に失敗しました', '手動収集の要求に失敗しました。'));
        setMessageDialogOpen(true);
        setSelectDevIndex(0);
      })
      .finally(() => {
        setSelectDevIndex(0);
        setOkCancelDialogOpen(false);
        setRowno(-1);
      });
  };

  /**
   * PLC再収集キャンセル要求OK処理
   */
  const handlePLCRecollectionCancelOK = () => {
    PLCRecollectionCancelRequest(selectDevIndex)
      .then((ret) => {
        if (ret.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          setShowMessage(t('DeviceListGrid.再収集キャンセルを要求しました', '再収集キャンセルを要求しました'));
          deviceArray[rowno].IsManualColection = 7;
          setDeviceArray(deviceArray.concat());
        } else if (ret.ErrorCode === ErrorCode.ERR_CODE_PLC_REQUEST_DUPLICATION) {
          setShowMessage(t('DeviceListGrid.既に再収集キャンセル要求中です', '既に再収集キャンセル要求中です'));
        } else {

          setShowMessage(t('DeviceListGrid.再収集キャンセルの要求に失敗しました', '再収集キャンセルの要求に失敗しました。'));
        }
        setMessageDialogOpen(true);
      })
      .catch((error) => {
        setShowMessage(t('DeviceListGrid.再収集キャンセルの要求に失敗しました', '再収集キャンセルの要求に失敗しました。'));
        setMessageDialogOpen(true);
        setSelectDevIndex(0);
      })
      .finally(() => {
        setSelectDevIndex(0);
        setOkCancelDialogOpen(false);
        setRowno(-1);
      });
  };

  /**
   * 手動収集要求
   * @param devRow 
   */
  const handlePLCManualCollectionButton = (devRow: DeviceLists) => {
    if (devRow[0].IsManualColection === 0) {
      setManualCollectionActionType('manualRequest');
      setShowMessage(t('DeviceListGrid.手動収集を要求しますか', '手動収集を要求しますか?'));
      setOkCancelDialogOpen(true);
      setSelectDevIndex(devRow[0].V_DEV_LIST_DISP.DEV_INDEX);
    }
  };

  /**
   * 再収集キャンセル要求
   * @param devRow 
   */
  const handlePLCRecollectionCancelButton = (devRow: DeviceLists) => {
    if (devRow[0].IsManualColection === 6) {
      setManualCollectionActionType('recollectionCancelRequest');
      setShowMessage(t('DeviceListGrid.再収集キャンセルを要求しますか', '再収集キャンセルを要求しますか?'));
      setOkCancelDialogOpen(true);
      setSelectDevIndex(devRow[0].V_DEV_LIST_DISP.DEV_INDEX);
    }
  };
  /**
   * 処理要求の切替
   * @returns 
   */
  const changeDialogOK = () => {
    if (manualCollectionActionType === 'recollectionCancelRequest') {
      handlePLCRecollectionCancelOK();
      return;
    }
    handlePLCManualCollectionOK();
  };

  const getManualColectionString = (sate?: number): string => {
    if (sate == undefined) return t('DeviceListGrid.不明', '不明');

    switch (sate) {
      case 0:
        return t('DeviceListGrid.開始', '開始');
      case 1:
        return t('DeviceListGrid.自動中', '自動中');
      case 2:
        return t('DeviceListGrid.リトライ中', 'リトライ中');
      case 3:
        return t('DeviceListGrid.手動中', '手動中');
      case 4:
        return t('DeviceListGrid.学習中', '学習中');
      case 5:
        return t('DeviceListGrid.待機中', '待機中');
        case 6:
          return t('DeviceListGrid.再収集中', '再収集中');
        case 7:
          return t('DeviceListGrid.再収集停止中', '再収集停止中');
      case 9:
        return t('DeviceListGrid.収集不可', '収集不可');
      default:
        return t('DeviceListGrid.不明', '不明');
    }
  };

  /**
  * 機器一覧の取得
  * @returns 
  */
  const getData = (): DeviceLists | undefined => {
    fetch('api/DeviceList', {
      method: 'GET',
      headers: { pageName: 'Home' },
    })
      .then((res) => res.json())
      .then(
        (result: DeviceLists) => {
          console.debug(['Get result Data', 'api/DeviceList', result]);
          if (deviceListValidate(result)) setDeviceArray(result);
          return result;
        },
        (error) => {
          console.error('DeviceListGrid - getData');
          console.error(error);
        }
      );
    return undefined;
  };

  /**
   * 行クリックハンドラ
   * @param e 
   * @param index 
   */
  const handleTableCellClick = (e: V_DEV_LIST, index: number) => {
    console.debug(['handleTableCellClick', e, index]);
    if (selectedID == index + 1) {
      setDeviceIndex(e.DEV_INDEX);
      GetAllGroupList(e.DEV_INDEX).then((ret) => {
        setGroupListInfo(ret);
        handleDialogShow();
      });
    }
  };

  /**
   * studyRequestAction実行
   * @param devRow
   * @param index
   */
  const studyRequestAction = (devRow: DeviceLists, index: number) => {
    console.debug('studyRequestAction実行');
    //console.debug(['studyRequestAction_devRow',devRow]);
    PLCStudyRequest(devRow[0].V_DEV_LIST_DISP.DEV_INDEX)
      .then((ret) => {
        //console.debug(['studyRequestAction_ret',ret]);
        if (ret.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          setShowMessage(t('DeviceListGrid.学習処理の要求しました', '学習処理を要求しました'));
          deviceArray[index].IsLearning = false;
          setDeviceArray(deviceArray.concat());
        } else if (ret.ErrorCode === ErrorCode.ERR_CODE_PLC_REQUEST_DUPLICATION) {
          setShowMessage(t('DeviceListGrid.既に要求中です', '既に要求中です'));
        } else {
          setShowMessage(t('DeviceListGrid.学習処理の要求に失敗しました', '学習処理の要求に失敗しました。'));
        }
        setMessageDialogOpen(true);
      })
      .catch((error) => {
        setShowMessage(t('DeviceListGrid.学習処理の要求に失敗しました', '学習処理の要求に失敗しました。'));
        setMessageDialogOpen(true);
        setSelectDevIndex(0);
        console.error(['studyRequestAction_error', error]);
      })
      .finally(() => {
        setSelectDevIndex(0);
        setOkCancelDialogOpen(false);
        setRowno(-1);
      });
  };

  /**
   * studyCancelRequestAction実行
   * @param devRow
   * @param index
   */
  const studyCancelRequestAction = (devRow: DeviceLists, index: number) => {
    console.debug('studyCancelRequestAction実行');
    //console.debug(['studyRequestAction_devRow',devRow]);
    PLCStudyCancelRequest(devRow[0].V_DEV_LIST_DISP.DEV_INDEX)
      .then((ret) => {
        //console.debug(['studyRequestAction_ret',ret]);
        if (ret.ErrorCode === ErrorCode.ERR_CODE_NONE) {
          setShowMessage(t('DeviceListGrid.学習キャンセル処理の要求しました', '学習キャンセル処理を要求しました'));
          deviceArray[index].IsLearning = false;
          setDeviceArray(deviceArray.concat());
        } else if (ret.ErrorCode === ErrorCode.ERR_CODE_PLC_REQUEST_DUPLICATION) {
          setShowMessage(t('DeviceListGrid.既にキャンセル要求中です', '既にキャンセル要求中です'));
        } else {
          setShowMessage(
            t('DeviceListGrid.学習キャンセル処理の要求に失敗しました', '学習キャンセル処理の要求に失敗しました。')
          );
        }
        setMessageDialogOpen(true);
      })
      .catch((error) => {
        setShowMessage(
          t('DeviceListGrid.学習キャンセル処理の要求に失敗しました', '学習キャンセル処理の要求に失敗しました。')
        );
        setMessageDialogOpen(true);
        setSelectDevIndex(0);
        console.error(['studyCancelRequestAction_error', error]);
      })
      .finally(() => {
        setSelectDevIndex(0);
        setOkCancelDialogOpen(false);
        setRowno(-1);
      });
  };

  const lrdlg = flgLearnResDlg ? <LearnResultDialog dialog={learnResDlg} devIndex={deviceIndex} /> : null;

  //行選択の背景色一時置き
  let lineSelection = '';

  //console.debug([' - 画面描画開始 -', deviceArray]);
  return (
    <>
      <div className={`${(lineSelection = classes.tableRow)} ${(lineSelection = baseClasses.bodyRow)}`}></div>
      <TableContainer component={Paper} className={props.tableContainerStyle}>
        <Table stickyHeader aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableHeaderCell}>{t('DeviceListGrid.No', 'No')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('DeviceListGrid.機器番号_名称', '機器番号・名称')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('DeviceListGrid.状態', '状態')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('DeviceListGrid.最新収集時刻', '最新収集時刻')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('DeviceListGrid.手動収集', '手動収集')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>
                {t('DeviceListGrid.次回収集予定', '次回収集予定')}
              </TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('DeviceListGrid.周期', '周期')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('DeviceListGrid.学習処理', '学習処理')}</TableCell>
              <TableCell className={classes.tableHeaderCell}>{t('DeviceListGrid.学習結果', '学習結果')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {deviceArray.map((row, index) => (
              <TableRow
                key={index}
                hover
                onClick={() => {
                  setSelectedID(index + 1);
                }}
                selected={selectedID === index + 1}
                className={lineSelection}
              >
                {/**No */}
                <TableCell
                  className={classes.tableCell}
                  onClick={(e) => handleTableCellClick(row.V_DEV_LIST_DISP, index)}
                >
                  {index + 1}
                </TableCell>
                {/**機器番号・名称 */}
                <TableCell
                  className={classes.tableCell}
                  onClick={(e) => handleTableCellClick(row.V_DEV_LIST_DISP, index)}
                >
                  {row.V_DEV_LIST_DISP.DEV_NO + row.V_DEV_LIST_DISP.DEV_NAME}
                </TableCell>
                {/**状態 */}
                <TableCell className={classes.tableCell}>
                  <DeviceListStatErrorButton devList={row.V_DEV_LIST_DISP}></DeviceListStatErrorButton>
                </TableCell>
                {/**最新収集時刻 */}
                <TableCell
                  className={classes.tableCell}
                  onClick={(e) => handleTableCellClick(row.V_DEV_LIST_DISP, index)}
                >
                  <DateTImeDiv value={row.V_DEV_LIST_DISP.COL_TIME} format={'YY/MM/DD HH:mm:ss'} />
                </TableCell>
                {/**手動収集 */}
                <TableCell className={classes.tableCell}>
                  <Button
                    style={{
                      width: '130px',
                    }}
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      //再収集キャンセル処理か手動収集処理かを判断して、ボタンの表示と処理を切り替える
                      if (row.IsManualColection === 6) {
                        //再収集キャンセル処理
                        handlePLCRecollectionCancelButton([row]);
                      } else {
                        //手動収集処理
                        handlePLCManualCollectionButton([row]);
                      }
                      setRowno(index);
                    }}
                    disabled={row.IsManualColection !== 0 && row.IsManualColection !== 6}
                  >
                    {getManualColectionString(row.IsManualColection)}
                  </Button>
                </TableCell>
                {/**次回収集予定 */}
                <TableCell
                  className={classes.tableCell}
                  onClick={(e) => handleTableCellClick(row.V_DEV_LIST_DISP, index)}
                >
                  <DateTImeDiv value={row.V_DEV_LIST_DISP.SCHEDULE_TIME} format={'YY/MM/DD HH:mm:ss'} />
                </TableCell>
                {/**周期 */}
                <TableCell
                  className={classes.tableCell}
                  onClick={(e) => handleTableCellClick(row.V_DEV_LIST_DISP, index)}
                >
                  {row.V_DEV_LIST_DISP.DSP_STR}
                </TableCell>
                {/**学習処理 */}
                <TableCell className={classes.tableCell}>
                  <DevListStudyButton
                    //部分放電とコナンエアーの場合は使用不可を表示
                    studyStatus={
                      IsPartialDischargePlc(String(row.V_DEV_LIST_DISP.PLC_NO)) ||
                        IsConanAirPlc(String(row.V_DEV_LIST_DISP.PLC_NO))
                        ? LearnStatType.UNUSABLE
                        : row.V_DEV_LIST_DISP.LEARN_STAT ?? 0
                    }
                    isStudyCheck={row.IsLearning}
                    onClick={() => {
                      setRowno(index);
                      studyRequestAction([row], index);
                    }}
                    onCancelClick={() => {
                      setRowno(index);
                      studyCancelRequestAction([row], index);
                    }}
                  />
                </TableCell>
                {/**学習結果 */}
                {IsPartialDischargePlc(String(row.V_DEV_LIST_DISP.PLC_NO)) ||
                  IsConanAirPlc(String(row.V_DEV_LIST_DISP.PLC_NO)) ? (
                  <TableCell className={classes.tableCell}>
                    {/**部分放電とコナンエアーの場合はハイフンを表示*/}―
                  </TableCell>
                ) : (
                  <TableCell className={classes.tableCell}>
                    <DevListLearnResultButton
                      learnStat={row.V_DEV_LIST_DISP.LEARN_STAT ?? 0}
                      cv_c={row.V_DEV_LIST_DISP.CV_C}
                      cv_v={row.V_DEV_LIST_DISP.CV_V}
                      onClick={() => {
                        setDeviceIndex(row.V_DEV_LIST_DISP.DEV_INDEX);
                        learnResDlg.open();
                      }}
                    />
                  </TableCell>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/**グループ一覧ダイアログ表示 */}
      <Dialog open={open} fullWidth maxWidth="lg">
        <DialogTitle id="alert-dialog-title">{t('DeviceListGrid.グループ一覧', 'グループ一覧')}</DialogTitle>
        <DialogContent>
          <GropuListComGrid
            deviceIndex={deviceIndex}
            groupInfo={groupListInfo}
            onDataSelectAction={handleTransitionPage}
          />
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            disableElevation
            onClick={handleDialogClose}
          >
            {t('DeviceListGrid.閉じる', '閉じる')}
          </Button>
        </DialogActions>
      </Dialog>
      <OKCancelDialog
        open={okCancelDialogOpen}
        onOK={changeDialogOK}
        onCancel={() => setOkCancelDialogOpen(false)}
        title={t('DeviceListGrid.確認', '確認')}
        okText={t('DeviceListGrid.OK', 'OK')}
        cancelText={t('DeviceListGrid.キャンセル', 'キャンセル')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </OKCancelDialog>
      <SimpleDialog
        open={messageDialogOpen}
        onClose={() => setMessageDialogOpen(false)}
        title={t('DeviceListGrid.確認', '確認')}
        okText={t('DeviceListGrid.OK', 'OK')}
        maxWidth={'sm'}
      >
        <Typography>{showMessage}</Typography>
      </SimpleDialog>
      {lrdlg}
    </>
  );
};
export default DeviceListGrid;
